import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["description", "format", "component", "play"];
  toggle(event) {
    let target = event.currentTarget.dataset.id;
    let el = document.getElementById(target);
    el.classList.toggle("hidden");

    let icon = document.getElementById(`svg-${target}`);
    icon.classList.toggle('icon-rotate');
  }

  toggleDescription() {
    for (let el of this.descriptionTargets) {
      el.classList.toggle("hidden");
    }
  }

  toggleFormat() {
    for (let el of this.formatTargets) {
      el.classList.toggle("hidden");
    }
  }

  toggleComponent(event) {
    if (event.target) { event.target.classList.toggle("active") };
    for (let el of this.componentTargets) {
      el.classList.toggle("hidden");
    }
  }

  toggleTabsComponent(event) {
    var tab = document.getElementById('tabs');
    for (var i = 0; i < tab.children.length; i++) {
      tab.children[i].classList.remove("active");
    }

    var el = event.currentTarget;
    el.classList.add('active');

    this.componentTargets.forEach((component) =>
      component.classList.add("hidden"),
    )

    let target = event.target.dataset.target;
    let content = document.getElementById(target);
    content.classList.toggle("hidden");
  }

  toggleDrawer() {
    let el = document.getElementById('modal-component');
    el.classList.toggle("hidden");

    let main = document.getElementById('main');
    main.classList.toggle('scroll-disable');
  }

  togglePlay() {
    let el = document.getElementById('how-to-play-component');
    el.classList.toggle("hidden");

    let icon = document.getElementById('open-icon');
    icon.classList.toggle('icon-rotate');
  }
}